<app-container [testHook]="testHooks.Container">
	<div class="flex flex-col">
		<div class="flex justify-between items-center">
			<div class="flex items-center">
				<h4 class="mb-0 text-lg">{{ title.pinNumber }}</h4>
				<div
					class="ml-2 my-2 border-l-2 border-grey-light flex"
					*ngIf="title.primary"
				>
					<app-icon
						class="ml-1"
						[icon]="ICON.STAR"
						[testHook]="testHooks.StarIcon"
					></app-icon>
					<span class="ml-2">Primary</span>
				</div>
			</div>
			<div class="flex items-center">
				<atomic-kebab-options
					(onSelect)="onKebabOptionSelected($event)"
					[itemGroups]="[{ items: additionalKebabOptions }]"
					[testHook]="testHooks.KebabOptions"
				></atomic-kebab-options>
			</div>
		</div>

		<div>
			<p class="text-lg overflow-hidden text-ellipsis whitespace-nowrap">
				{{ title.legalDescription }}
			</p>
		</div>
		<div class="flex flex-wrap">
			<app-pill
				mode="secondary"
				class="m-2"
				*ngIf="!isCondo && $any(title).lot"
				[testHook]="testHooks.Pill"
			>
				Lot {{ title.lot }}</app-pill
			>

			<app-pill
				mode="secondary"
				class="m-2"
				*ngIf="isCondo && $any(title).unitType"
				[testHook]="testHooks.Pill1"
			>
				{{ title.unitType }}</app-pill
			>
			<app-pill
				mode="secondary"
				class="m-2"
				*ngIf="isCondo && $any(title).unitNumber"
				[testHook]="testHooks.Pill2"
			>
				Unit {{ title.unitNumber }}</app-pill
			>
			<app-pill
				mode="secondary"
				class="m-2"
				*ngIf="isCondo && $any(title).levelNumber"
				[testHook]="testHooks.Pill3"
			>
				Level {{ title.levelNumber }}</app-pill
			>
			<app-pill
				mode="secondary"
				class="m-2"
				*ngIf="title.planName"
				[testHook]="testHooks.Pill4"
			>
				{{ title.planName }}</app-pill
			>
		</div>

		<ng-container *ngIf="isCondo">
			<hr class="my-4" />
			<div class="flex justify-end items-center text-lg">
				<label class="font-bold mr-4 text-lg">Common expenses</label>
				{{ getCommonExpensesTotal() | centsToDollars }}
			</div>
		</ng-container>
	</div>
</app-container>
